import { memo, type ReactNode } from 'react';

import { SquareKanbanIcon } from '@air/design-icons';

import { NullState } from '~/components/NullState';

export type KanbanNullStateProps = {
  action?: ReactNode;
  title: string;
  text: ReactNode;
};

export const KanbanNullState = memo(({ action, text, title }: KanbanNullStateProps) => (
  <div className="size-full" data-testid="KANBAN_NULL_STATE">
    <NullState
      icon={SquareKanbanIcon}
      title={title}
      description={<span data-testid="KANBAN_NULL_STATE_TEXT">{text}</span>}
    >
      {!!action && (
        <div className="flex gap-2" data-testid="KANBAN_NULL_STATE_ACTION">
          {action}
        </div>
      )}
    </NullState>
  </div>
));

KanbanNullState.displayName = 'KanbanNullState';
